import React, { useState, useEffect, useRef } from 'react';
import { breakpoints } from '../../../../../config/constants';
import CardMedia from '../../../../CardMedia';
import ArticleCardBase from '../../Base';
import { inheritChildStyle } from '../../../../../helpers/text';

import './styles.scss';

const fixTextLink = cardTextElem => {
  inheritChildStyle(cardTextElem, 'u', 'color');
  inheritChildStyle(cardTextElem, 'a', 'color');
};

/*
 * Splitted the contents into two separate Cards.
 * This is for both cards to have proper scroll snapping.
 */
const LandscapeImageCard1Mobile = ({ data, cardTextRef, endCard }) => {
  const { backgroundColor, sectionTitle, paragraphC8, articleAsset, imageFit } = data;

  useEffect(() => {
    if (cardTextRef.current) {
      fixTextLink(cardTextRef.current);
    }
  }, []);

  return (
    <>
      <ArticleCardBase accentColor1={backgroundColor} variation="landscape" endCard={endCard}>
        <section className="card-container landscape-image-card-1">
          <div className="landscape-image-card-1__slide">
            <div
              className="landscape-image-card-1__title"
              dangerouslySetInnerHTML={{ __html: sectionTitle }}
            />
            <div
              ref={cardTextRef}
              className="landscape-image-card-1__text"
              dangerouslySetInnerHTML={{ __html: paragraphC8 }}
            />
          </div>
        </section>
      </ArticleCardBase>
      <ArticleCardBase accentColor1={backgroundColor} variation="landscape">
        <section className="card-container landscape-image-card-1">
          {articleAsset.length ? (
            <div className="landscape-image-card-1__asset-wrapper">
              <CardMedia
                url={articleAsset[0].url}
                title={articleAsset[0].title}
                mimeType={articleAsset[0].mimeType}
                mediaContainerClasses="landscape-image-card-1__media-container"
                mediaClasses="landscape-image-card-1__media"
                imageFit={imageFit}
                cardImageSizes={[{ actual: 327, intrinsic: 780 }]}
                loop
                isAutoplay
              />
            </div>
          ) : null}
        </section>
      </ArticleCardBase>
    </>
  );
};
const LandscapeImageCard1 = ({ data, endCard }) => {
  const [isMobileCardView, setIsMobileCardView] = useState(false);
  const cardTextRef = useRef();
  const { backgroundColor, sectionTitle, paragraphC8, articleAsset, imageFit } = data;

  function checkResize() {
    const isMobileView = window.innerWidth < breakpoints.smallDesktop;

    setIsMobileCardView(isMobileView);
  }

  useEffect(() => {
    if (cardTextRef.current) {
      fixTextLink(cardTextRef.current);
    }

    window.addEventListener('resize', checkResize);
    checkResize();

    return () => {
      window.removeEventListener('resize', checkResize);
    };
  }, []);

  return isMobileCardView ? (
    <LandscapeImageCard1Mobile data={data} cardTextRef={cardTextRef} endCard={endCard} />
  ) : (
    <ArticleCardBase variation="landscape" accentColor1={backgroundColor} endCard={endCard}>
      <section className="card-container landscape-image-card-1">
        <div className="landscape-image-card-1__slide">
          <div
            className="landscape-image-card-1__title"
            dangerouslySetInnerHTML={{ __html: sectionTitle }}
          />
          <div
            ref={cardTextRef}
            className="landscape-image-card-1__text"
            dangerouslySetInnerHTML={{ __html: paragraphC8 }}
          />
        </div>
        {articleAsset.length ? (
          <div className="landscape-image-card-1__asset-wrapper">
            <CardMedia
              url={articleAsset[0].url}
              title={articleAsset[0].title}
              mimeType={articleAsset[0].mimeType}
              mediaContainerClasses="landscape-image-card-1__media-container"
              mediaClasses="landscape-image-card-1__media"
              imageFit={imageFit}
              cardImageSizes={[{ actual: 575, intrinsic: 860 }]}
              loop
              isAutoplay
            />
          </div>
        ) : null}
      </section>
    </ArticleCardBase>
  );
};

export default LandscapeImageCard1;
